import { HeaderTitle } from 'css/CommonStyle'
import { urlQueryParser } from 'services/util'

import { HeaderBackground } from '../components/CommonStyles'
import DashboardHeader from '../images/dashboard-top-background-banner.jpg'
import NonAuthEiarReports from './components/NonAuthEiarReports'

function NonAuthReport(props) {
  const { reportType, reportYear, publicId } = urlQueryParser(props.location.search)

  return (
    <HeaderBackground className="background-grey" headerImage={DashboardHeader}>
      <div className="wrapper m-no-padding">
        <HeaderTitle className="h1 center has-no-margins hide-on-print" id="landingPageTitle">Reports</HeaderTitle>

        {reportType === 'EIAR' &&
          <NonAuthEiarReports
            reportYear={reportYear}
            publicId={publicId}
          />}
      </div>
    </HeaderBackground>
  )
}

export default NonAuthReport
